import { CoreoRecordSyncStatus } from './types';

/**
 * Sync states that count as "ready" for associate trees (e.g. save gating, pending upload filtering).
 * Kept outside `store/` so DB and other layers can align with form logic without importing Redux.
 */
export const READY_SYNC_STATES = new Set([
  CoreoRecordSyncStatus.SUBMITTED,
  CoreoRecordSyncStatus.PENDING_UPDATE,
  CoreoRecordSyncStatus.PENDING_DELETE
]);

export const READY_TO_BE_READY_SYNC_STATES = new Set([
  CoreoRecordSyncStatus.SUBMITTED,
  CoreoRecordSyncStatus.PENDING_UPDATE,
  CoreoRecordSyncStatus.PENDING_DELETE,
  CoreoRecordSyncStatus.DRAFT
]);
